<div class="allocate-quantity-container">
  @if (showInputBox) {
    <div class="quantity" [ngClass]="{ 'border-red': isInvalidUserInput }">
      <ra-ui-input
        class="quantity-input"
        [value]="availableQuantity"
        label=""
        width="65px"
        height="25px"
        (valueChange)="onInputChange($event)"
        [config]="{
          fillParent: true,
          textAlign: 'Center',
          inputType: numericInputType,
          displayType: unsignedIntegerDisplayType,
          enableFlatMode: true,
        }"
      ></ra-ui-input>
    </div>
    <div class="quantity">
      <span> / {{ availableEntitlement }}</span>
    </div>
  } @else {
    @if (availableEntitlement > 1) {
      <div>1 / {{ availableEntitlement }}</div>
    } @else {
      <div>{{ availableEntitlement }}</div>
    }
  }
</div>
